import { useSelector } from 'react-redux';

import type { FilterConfig } from '../interfaces/filterConfig';
import { selectFiltersConfig } from '../selectors/filtersConfig';
import { getGenericFiltersConfig } from '../services/algolia/filterConfig/filterConfigs';

const genericFiltersConfig = getGenericFiltersConfig();

export const useFilterConfigs = (): FilterConfig[] => {
  const filtersConfig = useSelector(selectFiltersConfig);

  return filtersConfig || genericFiltersConfig;
};
